
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"opacity":".4","d":"M26.346 8.611l-7.944 6.531c-.695.57-1.792.109-1.792-.78v-.68l4.903-4.03c.275-.226.495-.506.646-.82a2.309 2.309 0 000-2.003 2.421 2.421 0 00-.646-.82L16.61 1.98V1.3c0-.887 1.096-1.351 1.792-.78l7.944 6.531c.118.097.212.217.277.352a.99.99 0 010 .858c-.065.134-.159.254-.277.351z","fill":"#65B041"}}),_c('path',{attrs:{"d":"M20.569 8.611l-7.945 6.531c-.695.57-1.792.109-1.792-.78v-3.618c-4.905.539-6.82 2.53-5.082 7.82.226.692-.65 1.228-1.267.801C2.508 17.998.72 15.383.72 12.743c0-5.643 4.28-7.447 10.111-7.887V1.3c0-.887 1.096-1.351 1.792-.78L20.57 7.05c.117.097.212.217.276.352a.99.99 0 010 .858c-.064.134-.159.254-.276.351z","fill":"#65B041"}})])
          )
        }
      }
    